// Write your code here
import './index.css'

const TransactionItem = props => {
  const {transactionDetails, deleteTransaction} = props
  const {id, title, amount, type} = transactionDetails

  // Determine display label matching transaction type ID
  const typeDisplay = type === 'INCOME' ? 'Income' : 'Expenses'

  const onDelete = () => {
    deleteTransaction(id)
  }

  return (
    <li className="table-row">
      <p className="table-cell">{title}</p>
      <p className="table-cell">Rs {amount}</p>
      <p className="table-cell">{typeDisplay}</p>
      <div className="delete-cell">
        <button
          type="button"
          className="delete-btn"
          onClick={onDelete}
          data-testid="delete"
        >
          <img
            src="https://assets.ccbp.in/frontend/react-js/money-manager/delete.png"
            alt="delete"
            className="delete-icon"
          />
        </button>
      </div>
    </li>
  )
}

export default TransactionItem
